/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { UploadTypeEnum } from "./UploadTypeEnum";
import {
  UploadTypeEnumFromJSON,
  UploadTypeEnumFromJSONTyped,
  UploadTypeEnumToJSON,
  UploadTypeEnumToJSONTyped,
} from "./UploadTypeEnum";
import type { FileStateEnum } from "./FileStateEnum";
import {
  FileStateEnumFromJSON,
  FileStateEnumFromJSONTyped,
  FileStateEnumToJSON,
  FileStateEnumToJSONTyped,
} from "./FileStateEnum";

/**
 *
 * @export
 * @interface ModelFile
 */
export interface ModelFile {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly storageName?: string;
  /**
   *
   */
  filename: string;
  /**
   *
   */
  bucket: string;
  /**
   *
   */
  prefix?: string | null;
  /**
   * Optional eTag (md5sum)
   */
  etag?: string | null;
  /**
   * Filesize in bytes
   */
  size?: number | null;
  /**
   *
   */
  expiryDate?: Date;
  /**
   *
   */
  readonly relatedObject?: string;
  /**
   *
   */
  type: UploadTypeEnum;
  /**
   *
   */
  state: FileStateEnum;
  /**
   *
   */
  stateDescription?: string | null;
  /**
   *
   */
  meta?: any | null;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the ModelFile interface.
 */
export function instanceOfModelFile(value: object): value is ModelFile {
  if (!("filename" in value) || value["filename"] === undefined) return false;
  if (!("bucket" in value) || value["bucket"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  return true;
}

export function ModelFileFromJSON(json: any): ModelFile {
  return ModelFileFromJSONTyped(json, false);
}

export function ModelFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelFile {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    storageName: json["storage_name"] == null ? undefined : json["storage_name"],
    filename: json["filename"],
    bucket: json["bucket"],
    prefix:
      json["prefix"] === undefined ? undefined : json["prefix"] === null ? null : json["prefix"],
    etag: json["etag"] === undefined ? undefined : json["etag"] === null ? null : json["etag"],
    size: json["size"] === undefined ? undefined : json["size"] === null ? null : json["size"],
    expiryDate: json["expiry_date"] == null ? undefined : parseDate(json["expiry_date"]),
    relatedObject: json["related_object"] == null ? undefined : json["related_object"],
    type: UploadTypeEnumFromJSON(json["type"]),
    state: FileStateEnumFromJSON(json["state"]),
    stateDescription:
      json["state_description"] === undefined
        ? undefined
        : json["state_description"] === null
        ? null
        : json["state_description"],
    meta: json["meta"] === undefined ? undefined : json["meta"] === null ? null : json["meta"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function ModelFileToJSON(json: any): ModelFile {
  return ModelFileToJSONTyped(json, false);
}

export function ModelFileToJSONTyped(
  value?: Omit<ModelFile, "url" | "storageName" | "relatedObject" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    filename: value["filename"],
    bucket: value["bucket"],
    prefix: value["prefix"],
    etag: value["etag"],
    size: value["size"],
    expiry_date:
      value["expiryDate"] == null ? value["expiryDate"] : serializeDate(value["expiryDate"]),
    type: UploadTypeEnumToJSON(value["type"]),
    state: FileStateEnumToJSON(value["state"]),
    state_description: value["stateDescription"],
    meta: value["meta"],
  };
}
